
    import './styles.scoped.css';
    export default {
  "content-inner": "awsui_content-inner_1mwlm_oyjaq_5"
};
  